import { render, staticRenderFns } from "./keselarasan_kinerja.vue?vue&type=template&id=20fe7024&"
import script from "./keselarasan_kinerja.vue?vue&type=script&lang=js&"
export * from "./keselarasan_kinerja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports